<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" :rules="rules" ref="orderInfo" label-width="150px" class="orderinfo-form" size="mini">
                    <el-row>
                            <el-form-item label="订单编号" prop="orderCode">
                                <el-input v-model="orderInfo.orderCode" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户姓名" prop="customerName">
                                <el-input v-model="orderInfo.customerName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-tooltip :disabled="experimentNumTooltipDisabled" :content="experimentNumContent" placement="top">
                                <el-form-item label="载体名称" prop="carrierName">
                                    <el-input v-model="orderInfo.carrierName" :readonly="true"></el-input>
                                </el-form-item>
                            </el-tooltip>
                            <el-form-item label="样品编号" prop="sampleNum">
                                <el-input v-model="orderInfo.sampleNum" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="实验编号" prop="experimentNum">
                                <el-input v-model="orderInfo.experimentNum" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="插入片段" prop="insertFragment">
                                <el-input v-model="orderInfo.insertFragment" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="是否已经纯化" prop="isPurifyingDesc">
                                <el-input v-model="orderInfo.isPurifyingDesc" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="上游位点" prop="upstreamSiteName">
                                <el-input v-model="orderInfo.upstreamSiteName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="下游位点" prop="downstreamSiteName">
                                <el-input v-model="orderInfo.downstreamSiteName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="是否测序" prop="isSequencingDesc">
                                <el-input v-model="orderInfo.isSequencingDesc" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="阳性克隆数" prop="positiveCloneNum">
                                <el-input v-model="orderInfo.positiveCloneNum" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="测序引物名称" prop="sequencePrimerName">
                                <el-input v-model="orderInfo.sequencePrimerName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="插入片段序列" prop="insertFragmentSeq">
                                <el-input v-model="orderInfo.insertFragmentSeq" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="订单状态" prop="orderStatusDesc">
                                <el-input v-model="orderInfo.orderStatusDesc" :readonly="true"></el-input>
                            </el-form-item>                            
                            <el-form-item label="加测引物碱基数">
                                <el-input v-model="orderInfo.companyKtr" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="测序反应数">
                                <el-input v-model="orderInfo.companyJkr" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="生工">
                                <el-input v-model="orderInfo.companySg" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="擎科">
                                <el-input v-model="orderInfo.companyQk" :readonly="true"></el-input>
                            </el-form-item>                            
                            <el-form-item label="测序结果" prop="resultFileName">
                                <el-input v-model="orderInfo.resultFileName" :readonly="true">
                                    <el-button  slot="append"  @click="toDownload" style="background-color:#67C23A;color:#FFF;border-color:#67C23A;">下载</el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="订单金额" prop="orderAmount">
                                <el-input v-model="orderInfo.orderAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户结算金额" prop="customSettlementAmount">
                                <el-input v-model="orderInfo.customSettlementAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="代理结算金额" prop="agentSettlementAmount">
                                <el-input v-model="orderInfo.agentSettlementAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="归属责任客户" prop="attributableCustomer">
                                <el-input v-model="orderInfo.attributableCustomer" :readonly="true">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="支付意愿确认" prop="payWillingness">
                                <el-select v-model="orderInfo.payWillingness" filterable clearable placeholder="请选择" >
                                    <el-option
                                    v-for="item in payWillingnesses"
                                    :key="item.dictCode"
                                    :label="item.dictDesc"
                                    :value="item.dictCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                    </el-row>
                    <el-row type="flex" style="justify-content: right;" class="button-row">
                        <el-button size="mini" type="primary" @click="submitForm('orderInfo')">提交</el-button>
                        <el-button size="mini" @click="cancel">取消</el-button>
                    </el-row>
                    <el-divider>构建系统</el-divider>
                    <div v-for="(item, index) in welcomeContents" :key="index">
                        <span>{{item}}</span>
                    </div>
                </el-form>
            </el-col>
        </el-row>
        
        
        <el-dialog title="用户列表" :visible.sync="userDialogVisible" append-to-body>
            <UserSearch></UserSearch>
        </el-dialog>
    </div>
</template>

<script>

import UserSearch from '../user/UserSearch.vue';
import GlobeConstant from '../../assets/js/GlobeConstant.js';

export default {
    name: "OrderInfoPay",
    props: ["orderInfoProp"],
    components: {
        UserSearch
    },
    data() {
        return {
            orderInfo: {
            },
            rules: {
                payWillingness: [
                    { required: true, message: "请选择支付意愿", trigger: "change" },
                ],
            },
            isDisabled: true,
            deliverys: [],
            isReceipts: [],
            confirmationReviews: [],
            userDialogVisible: false,
            salerButton: false,
            receiverButton: false,
            operatorButton: false,
            currentDialog: "",
            isClocker:false,
            isSaler:false,
            isReceiver:false,
            isOperator:false,
            isAuxiliary: false,
            isShowSaler: false,
            isShowReceiver: false,
            isShowOperator: false,
            isShowAuxiliary: false,
            isShowSettlementAmount: false,
            isShowRemark: false,
            experimentNumTooltipDisabled: true,
            experimentNumContent:'',
            quotationAmountTooltipDisabled: true,
            quotationAmountContent: '',
            fieldHis:{},
            isQuotationAmount: false,
            labelStyle:{"text-align":"right","margin-left":"100px"},
            welcomeContents:[],
            payWillingnesses:[],
        };
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'ORDER_STATUS') {
                            this.orderStatuses = res.data.result;
                        } else if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        }else if(dictType === 'PAY_WILLINGNESS') {
                            this.payWillingnesses = res.data.result;
                        }
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        handleClock(clockType) {
            let clock = {};
            clock.orderInfoId = this.orderInfo.orderInfoId;
            clock.clockType = clockType;
            this.$axios.post("/clock/punch",clock).then(
                res=>{
                    if(res.data.status === "success"){
                        if(clockType === 'CONNECT') {
                            // this.orderInfo.connectUser = res.data.result;
                            this.$set(this.orderInfo,"connectUser",res.data.result)
                        } else if(clockType === 'CONVERSION') {
                            // this.orderInfo.conversionUser = res.data.result;
                            this.$set(this.orderInfo,"conversionUser",res.data.result)
                        }else if(clockType === 'CLONE') {
                            // this.orderInfo.cloneUser = res.data.result;
                            this.$set(this.orderInfo,"cloneUser",res.data.result)
                        }else if(clockType === 'TESTING') {
                            // this.orderInfo.testingUser = res.data.result;
                            this.$set(this.orderInfo,"testingUser",res.data.result)
                        }else if(clockType === 'EXTRACT') {
                            // this.orderInfo.extractUser = res.data.result;
                            this.$set(this.orderInfo,"extractUser",res.data.result)
                        }else if(clockType === 'AMPLIFICATION') {
                            // this.orderInfo.amplificationUser = res.data.result;
                            this.$set(this.orderInfo,"amplificationUser",res.data.result)
                        }
                        this.$message({
                            message: "打卡成功！",
                            type: "success"
                        });                        
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        handleTczClock(clockType) {
            let clock = {};
            clock.orderInfoId = this.orderInfo.orderInfoId;
            clock.clockType = clockType;
            this.$axios.post("/clock/commissionPunch",clock).then(
                res=>{
                    if(res.data.status === "success"){
                        if(clockType === 'SALER') {
                            this.orderInfo.salerName = res.data.result.commission;
                        } else if(clockType === 'RECEIVER') {
                            this.orderInfo.receiverName = res.data.result.commission;
                        }else if(clockType === 'OPERATOR') {
                            this.orderInfo.operatorName = res.data.result.commission;
                        }else if(clockType === 'AUXILIARY') {
                            this.orderInfo.auxiliaryName = res.data.result.commission;
                        }
                        this.orderInfo.directorCommission = res.data.result.directorCommission;
                        this.$message({
                            message: "打卡成功！",
                            type: "success"
                        });                        
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        checkIsClocler() {
            if(this.user.roleCode === "CLOCK") {
                if(this.orderInfo.confirmationReview === 'REVIEWED') {
                    this.isClocker = true;
                }
                if(this.orderInfo.delivery === 'COMPLETED') {
                    this.isClocker = false;
                }
            }
        },
        checkIsCommissionHolder() {
            if(this.orderInfo.confirmationReview === 'REVIEWED') {
                if(this.user.roleCode === 'DIRECTOR' || this.user.roleCode === 'COMMISSION_HOLDER') {
                    if(!this.orderInfo.saler) {
                        this.isSaler = true;
                    }
                    if(!this.orderInfo.receiver) {
                        this.isReceiver = true;
                    }
                    if(!this.orderInfo.operator) {
                        this.isOperator = true;
                    }
                    if(!this.orderInfo.auxiliary) {
                        this.isAuxiliary = true;
                    }
                }
            }
            if(this.orderInfo.settlementAmount) {
                this.isSaler = false;
                this.isReceiver = false;
                this.isOperator = false;
                this.isAuxiliary = false;
            }
        },
        queryWelcomeContent() {
            var welcome = {
                'roleCode': this.user.roleCode
            }
            this.$axios.post("/welcome/findByRoleCode",welcome).then(
                res=>{
                    if(res.data.status === "success"){
                        this.welcomeContents = res.data.result;                    
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        toDownload() {
            if(!this.orderInfo.resultFileName) {
                this.$message.error('测序结果文件不存在，等待管理员上传之后，再进行下载！');
            }
            var param = {
                id:this.orderInfo.orderId
            }
            this.$axios.post("/order/downloadFile",param,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('下载成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        cancel() {
            this.$bus.$emit(GlobeConstant.orderinfoupdate_to_orderinfo_close);
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/order/updatePayWillingness", this.orderInfo).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "提交成功！",
                                type: "success"
                            });
                            this.$bus.$emit(GlobeConstant.orderinfoupdate_to_orderinfo_close);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },
    },
    created() {
        this.$bus.$on(GlobeConstant.usersearch_to_orderinfoupdate, this.setUserInfo);
        this.orderInfo = this.orderInfoProp;
        if(this.orderInfo.isOverTime) {
            this.$set(this.orderInfo,"term",this.orderInfo.term + " " + this.orderInfo.isOverTime);
        }
        this.$set(this.orderInfo,"",)
        this.queryDicts("PAY_WILLINGNESS");
        this.user = JSON.parse(window.localStorage.getItem("user"));
        this.checkIsClocler();
        this.checkIsCommissionHolder();
        this.queryWelcomeContent();

        if(this.user.roleCode === 'ADMIN' || this.user.roleCode === 'DIRECTOR') {
            this.isHasAuthority = true;
            this.isShowSaler= true;
            this.isShowReceiver= true;
            this.isShowOperator= true;
            this.isShowAuxiliary = true;
            this.isShowSettlementAmount= true;
            this.isShowRemark= true;
            this.isQuotationAmount = true;
        } else if(this.user.roleCode === 'COMMISSION_HOLDER') {
            this.isShowSaler= true
            this.isShowReceiver= true
            this.isShowOperator= true
            this.isShowAuxiliary = true;
            this.isShowSettlementAmount= true
            this.isQuotationAmount = true;
        }
    },
    mounted() {
    },
    beforeDestroy() {
    }
}


</script>

<style scoped>

    .orderinfo-form {
       margin: 20px 20px 20px 20px;
   }

   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .el-input-number {
        width: 220px;
    }
    .el-button >:span {
        background-color: blue;
    }
    .button-row {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
    }
    .button-row >.el-button {
        margin-top: 10px;
    }

</style>
